<template>
  <div style="padding-bottom: 50px;">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!-- 底部栏 -->
    <van-tabbar v-model="active" @change="change"
                style="background: #304250;"
                active-color="#fff"
                inactive-color="#aaa"
    >
      <van-tabbar-item icon="wap-home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="hotel-o">预定</van-tabbar-item>
      <van-tabbar-item icon="eye-o">发现</van-tabbar-item>
      <van-tabbar-item icon="contact">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      routers: ['/', '/order', '/news', '/me']
    }
  },
  mounted() {
    // 直接去会员系统
    let url = this.$route.query.backUrl
    if (url) {
      if (!url.includes('?')) url += '?'
      else url += '&'
      // 业务系统地址
      let homeSrc = encodeURIComponent(`${location.origin}${location.pathname}`)
      url += `memberId=${localStorage.getItem('openId')}&a=${localStorage.getItem('appId')}&t=${localStorage.getItem('server')}`
      url += `&homeSrc=${homeSrc}&token=${localStorage.getItem('hotel_token')}`
      location.href = url
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(n) {
        let active = this.routers.findIndex(item => item === n.path)
        if (active !== -1) this.active = active
        else this.active = 0
      }
    }
  },
  methods: {
    change(index) {
      this.$router.replace(this.routers[index])
    }
  }
}
</script>
